export const signOut = () => {
  sessionStorage.clear();
  localStorage.clear();
  window.location.reload();
};
